const selectors = {
  gallery: '[data-gallery]',
  progressBar: '[data-progress-bar]',
}

class ComponentProductGallery extends HTMLElement {
  constructor() {
    super();

    this.handleScroll = this.handleScroll.bind(this);
  }

  handleScroll() {
    const scrollLeft = this.gallery.scrollLeft;
    const itemWidth = window.innerWidth;
    const scrollWidth = this.gallery.scrollWidth;

    const progress = (scrollLeft + itemWidth) / scrollWidth;

    this.progressBar?.style.setProperty('--progress', progress);
  }

  connectedCallback() {
    this.container = this;
    this.gallery = this.querySelector(selectors.gallery);
    this.progressBar = this.querySelector(selectors.progressBar);
    
    this.gallery?.addEventListener('scroll', this.handleScroll);
  }
}

if (!customElements.get('product-gallery')) {
  customElements.define('product-gallery', ComponentProductGallery);
}